import type { CandidateModel } from '@/ui'
import { Tooltip } from '@/ui'
import { PaperclipIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export type CandidateAttachmentsBadgeProps = {
	files: CandidateModel['files']
}

export function CandidateAttachmentsBadge({ files }: CandidateAttachmentsBadgeProps) {
	const { t } = useTranslation('common')

	const totalCount = files?.total ?? 0

	if (!totalCount) {
		return null
	}

	const cvCount = files?.tagged.cv ?? 0
	const hasCv = cvCount > 0
	const otherCount = totalCount - cvCount

	const label = hasCv
		? (otherCount > 0 ? `${otherCount} + ${t('pipeline.cvShort')}` : t('pipeline.cvShort'))
		: `${totalCount}`

	const description = hasCv
		? (otherCount > 0
			? t('pipeline.sentCvAndFiles', { count: otherCount })
			: t('pipeline.sentCv'))
		: t('pipeline.sentFiles', { count: totalCount })

	return (
		<Tooltip content={description}>
			<span
				className="px-2 py-0.5 rounded-xl text-xs font-medium inline-flex items-center gap-1 justify-center min-w-[24px] bg-slate-200 text-slate-800"
				aria-label={description}
			>
				<PaperclipIcon className="size-3" aria-hidden="true" />
				{label}
			</span>
		</Tooltip>
	)
}
